import { createSlice } from "@reduxjs/toolkit";

const activeNavbarSlice = createSlice({
  name: "activeNavbar",
  initialState: "campaign_management",
  reducers: {
    setActiveNavbarTab: (_, action) => {
      return action.payload;
    },
  },
});

export const { setActiveNavbarTab } = activeNavbarSlice.actions;
export default activeNavbarSlice.reducer;
